import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-scroll";
import "./navbar.css";

function NavbarSection() {
  const [barCustomer, setBarCustomer] = useState(true);
  const [hideScroll, setHideScroll] = useState("block");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setBarCustomer(true);
      } else {
        setBarCustomer(false);
      }
    };

    const handleScroll = () => {
      if (window.scrollY > 600) {
        setHideScroll("none");
      } else {
        setHideScroll("block");
      }
    };

    // Run once on mount
    handleResize();

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMenu = () => {
    const offcanvas = document.querySelector(".offcanvas.show");
    if (offcanvas) {
      const backdrop = document.querySelector(".offcanvas-backdrop");
      const closeBtn = offcanvas.querySelector(".btn-close");
      if (closeBtn) closeBtn.click();
      if (backdrop) backdrop.click();
    }
  };

  return (
    <>
      <Navbar
        expand={barCustomer ? "lg" : false}
        fixed="top"
        className="bg-transparent navbar-dark shadow-none"
        style={{ display: hideScroll }}
      >
        <Container fluid>
          <Navbar.Brand href="#">
            <div className="d-inline-block mt-1">
              <span className="fs-3">
                <b>
                  Expl
                  <span>
                    <img
                      src="/images/logo2.png"
                      alt="Logo"
                      width="30"
                      height="30"
                    />
                  </span>
                  ration
                </b>
              </span>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand`}
            className="navTogglebtn"
          />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand`}
            aria-labelledby={`offcanvasNavbarLabel-expand`}
            placement="end"
            style={{ width: "35%" }}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title
                className="offcanvas-title"
                id={`offcanvasNavbarLabel-expand`}
              >
                Expl
                <span>
                  <img
                    src="/images/logo2.png"
                    alt="Logo"
                    width="20"
                    height="20"
                  />
                </span>
                ration
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <Link
                  to="home"
                  smooth={true}
                  duration={700}
                  offset={-80}
                  onClick={closeMenu}
                  className={`nav-link ${barCustomer ? "nav-link-white" : ""}`}
                  href=""
                >
                  Home
                </Link>
                <hr className="my-0 text-warning" />
                <Link
                  to="about"
                  smooth={true}
                  duration={700}
                  offset={-80}
                  onClick={closeMenu}
                  className={`nav-link ${barCustomer ? "nav-link-white" : ""}`}
                  href="#action2"
                >
                  About
                </Link>
                <hr className="my-0 text-warning" />
                <Link
                  to="services"
                  smooth={true}
                  duration={700}
                  offset={-80}
                  onClick={closeMenu}
                  className={`nav-link ${barCustomer ? "nav-link-white" : ""}`}
                  href="#action2"
                >
                  Services
                </Link>
                <hr className="my-0 text-warning" />
                <Link
                  to="blog"
                  smooth={true}
                  duration={700}
                  offset={-80}
                  onClick={closeMenu}
                  className={`nav-link ${barCustomer ? "nav-link-white" : ""}`}
                  href="#action2"
                >
                  Blog
                </Link>
                <hr className="my-0 text-warning" />
                <Link
                  to="contact"
                  smooth={true}
                  duration={700}
                  offset={-80}
                  onClick={closeMenu}
                  className={`nav-link ${barCustomer ? "nav-link-white" : ""}`}
                  href="#action2"
                >
                  Contact
                </Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
}

export default NavbarSection;
